import { render, staticRenderFns } from "./ClientAccount.vue?vue&type=template&id=df7fcbea"
import script from "./ClientAccount.vue?vue&type=script&lang=ts"
export * from "./ClientAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports